module.exports = __webpack_public_path__ + "static/media/tenant.2cc3cc89.svg";